import { useEffect, useState } from "react";
import { PartyPopper, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const BirthdayGreeting = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (user?.is_birthday) {
      const today = new Date().toISOString().slice(0, 10);
      const key = `bday_dismissed_${user.id}_${today}`;
      if (!localStorage.getItem(key)) setShow(true);
    }
  }, [user]);

  const dismiss = () => {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem(`bday_dismissed_${user.id}_${today}`, "1");
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="employee-birthday-greeting"
      className="relative overflow-hidden bg-gradient-to-r from-pink-500 to-rose-500 text-white px-6 py-4 flex items-center gap-4"
    >
      <div className="h-11 w-11 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center shrink-0">
        <PartyPopper className="h-6 w-6" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold tracking-tight text-lg">🎉 Happy Birthday {user?.name}!</div>
        <p className="text-white/85 text-sm">Wishing you a wonderful birthday and a fantastic year ahead. Have a great day!</p>
      </div>
      <button data-testid="dismiss-birthday-greeting" onClick={dismiss} className="text-white/80 hover:text-white p-1.5 transition-colors">
        <X className="h-5 w-5" />
      </button>
    </div>
  );
};
